import { render } from "./odn-modal-filters.vue?vue&type=template&id=3f49bc37"
const script = {}

import "./odn-modal-filters.vue?vue&type=style&index=0&id=3f49bc37&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__